<template>
  <landing-page
    :chamber="config.key"
    :chamberTitle="config.name"
    :loading="loading"
    :models="models"
    :currentModel="model"
    :landingModels="landingModels"
    :lastModelUpdate="lastModelUpdate"
    :meanSeat="meanSeat">
    <span slot="page-title">2022 {{ config.name }} Elections Model</span>
  </landing-page>
</template>

<script>
import LandingMixin from '@/mixins/landingPage'
import { mapGetters } from 'vuex';

const name = 'house_landing'

const computed = {
  ...mapGetters({
    meanSeat: 'aggregateModels/houseMeanSeat',
  }),
};

const mixins = [
  LandingMixin
]

const props = {
  config: {
    type: Object,
    default: () => {
      return {
        key: 'house',
        name: 'House',
        param: 'HOUSE'
      }
    }
  }
}

export default {
  name,
  mixins,
  props,
  computed,
  // TODO: get updated meta text
  metaInfo: {
    title: 'House',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'House'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'House'
      }, {
        vmid: 'description',
        name: 'description',
        content: '2022 U.S. election predictions for Senate and House Congressional elections. Includes model-driven predictions for key Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: '2022 U.S. election predictions for Senate and House Congressional elections. Includes model-driven predictions for key Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: '2022 U.S. election predictions for Senate and House Congressional elections. Includes model-driven predictions for key Senate and House races, polling and district information, and model simulations updated daily.'
      }
    ]
  }
}
</script>
